import { articleApi } from '../../article/services/articleApi'

import type { WorkflowRequestForm } from '../types/admin.types'

export const adminWorkflowApi = {
  listArticles: (params?: { state?: string }) => articleApi.list(params),
  assignArticleReviewer: (id: string | number, reviewerId: string | number) => articleApi.assignReviewer(id, reviewerId),
  approveArticle: (id: string | number) => articleApi.approve(id),
  rejectArticle: (id: string | number, comment: string) => articleApi.reject(id, comment),
  requestArticleChanges: (id: string | number, data: WorkflowRequestForm) => articleApi.requestChanges(id, data),
  publishArticle: (id: string | number) => articleApi.publish(id),
  archiveArticle: (id: string | number) => articleApi.archive(id),
}
